// "05 · Teaching and speaking" on home.

const SPEAKING_PULL =
	"Eight consecutive years on the stage, and a curriculum reaching over a million practitioners.";

const SPEAKING = [
	{
		date: "2018–2025",
		venue: "AWS re:Invent",
		qualifier: ", chalk talk and breakout speaker",
	},
	{
		date: "Various",
		venue: "AWS Global Summits",
		qualifier: ", Seattle, Washington DC, San Francisco",
	},
	{
		date: "2024",
		venue: "IEEE Cloud Summit",
		qualifier: ", Washington DC, plus Ai4 and ODSC",
	},
	{
		date: "Ongoing",
		venue: "Amazon ML University",
		qualifier:
			" and AWS Skill Builder: four self-served AI courses, 1.2M professionals reached",
	},
	{
		date: "Ongoing",
		venue: "Computer vision and NLP cohort",
		qualifier:
			", AWS Technical Field Community: founded and led, enabling early-career architects",
	},
];

export { SPEAKING_PULL, SPEAKING };
